import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import {useGLTF} from '@react-three/drei'
import {RigidBody} from '@react-three/rapier'
import {useSelector} from 'react-redux'
import {Float, Text} from '@react-three/drei'


const BlockEnd = ({position = [0,0,0]}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)

    const hamburger = useGLTF('./hamburger.glb')

    hamburger.scene.children.forEach((mesh)=>{mesh.castShadow = true})

    return (
        <group position={position}>
            {/* <Float floatIntensity={0.25} rotationIntensity={0.25}> */}
                <Text
                    font='./bebas-neue-v9-latin-regular.woff'
                    scale={8}
                    position={[0,2.25,2]}
                >
                    FINISH
                    <meshBasicMaterial toneMapped={false}/>
                </Text>
            {/* </Float> */}
            <mesh
                geometry={geometryCtx.boxGeometry}
                material={geometryCtx.floor1Material}
                scale={[4,0.2,4]}
                position={[0,0,0]}
                receiveShadow
            />
            <RigidBody type='fixed' colliders='hull' position={[0,0.25,0]} restitution={0.2} friction={0}>
                <primitive object={hamburger.scene} scale={0.2}/>
            </RigidBody>
        </group>
    )
}

export default BlockEnd